export default __webpack_public_path__ + "static/media/FUTURXKC.4f55998a.ttf";